import React, { useEffect, useState } from "react";
import GlobalDataTable from "../../../global/GlobalDataTable";
import GlobalFeedback from "../../../global/GlobalFeedback";
import { GlobalButton } from "../../../global/forms/GlobalFormFields";
import { getDonorReceipts } from "../api/donorPanelApi";
import { downloadMediaUrl } from "../../../utils/downloadMediaUrl";

export default function DonorDownloadReceipts() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [downloadingKey, setDownloadingKey] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getDonorReceipts();
        if (!alive) return;
        setRows(Array.isArray(res?.data) ? res.data : []);
      } catch (err) {
        if (!alive) return;
        setError(err?.message || "Failed to load receipts");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const onDownload = async (row) => {
    const key = `${row.donation_id}-${row.receipt_no}`;
    if (!row?.payment_proof) {
      setError("No payment proof available for this receipt.");
      return;
    }
    setError("");
    setDownloadingKey(key);
    try {
      await downloadMediaUrl(
        row.payment_proof,
        `payment-proof-${row.receipt_no || row.donation_id}`,
      );
    } catch (err) {
      setError(err?.message || "Download failed");
    } finally {
      setDownloadingKey(null);
    }
  };

  return (
    <div className="user-builder-panel">
      <h3 className="user-builder-panel__title">Download Receipts</h3>
      <GlobalFeedback type="error" text={error} />
      {loading ? (
        <p>Loading receipts...</p>
      ) : (
        <GlobalDataTable
          tableAriaLabel="Donor receipts table"
          headers={[
            { key: "receipt_no", label: "Receipt No" },
            { key: "download", label: "Download" },
          ]}
        >
          {rows.length === 0 ? (
            <tr>
              <td colSpan={2} style={{ textAlign: "center", padding: "1rem" }}>
                No receipts available.
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={`${row.donation_id}-${row.receipt_no}`}>
                <td>{row.receipt_no}</td>
                <td>
                  <GlobalButton
                    type="button"
                    size="sm"
                    variant="ghost"
                    loading={downloadingKey === `${row.donation_id}-${row.receipt_no}`}
                    onClick={() => onDownload(row)}
                  >
                    Download proof
                  </GlobalButton>
                </td>
              </tr>
            ))
          )}
        </GlobalDataTable>
      )}
    </div>
  );
}
